import { api } from "./api";

export async function fetchProductosAdmin() {
  const { data } = await api.get("/software/admin/productos");
  return data;
}

export async function subirArchivoSoftware(file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/software/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return data; // { archivo_path, archivo_nombre, size }
}

export async function crearProducto(payload) {
  const { data } = await api.post("/software/admin/productos", payload);
  return data;
}

export async function actualizarProducto(id, payload) {
  const { data } = await api.put(`/software/admin/productos/${id}`, payload);
  return data;
}

export async function eliminarProducto(id) {
  await api.delete(`/software/admin/productos/${id}`);
}

export async function toggleEstadoProducto(id) {
  const { data } = await api.patch(`/software/admin/productos/${id}/estado`);
  return data;
}

// ---------- Compra y descarga (usuarios) ----------
export async function comprarProducto(id) {
  const { data } = await api.post(`/software/${id}/comprar`, {
    origin_url: window.location.origin,
  });
  return data; // { url, session_id } | { comprado, gratis } | { comprado, ya_adquirido }
}

export async function fetchMisCompras() {
  const { data } = await api.get("/software/mis-compras");
  return data; // { items: [...] }
}

export async function descargarProducto(id) {
  const { data } = await api.post(`/software/${id}/descargar-link`);
  const base = process.env.REACT_APP_BACKEND_URL || "";
  // data.url = "/api/software/descargar?token=<jwt corto>" — autenticado por el token.
  window.open(`${base}${data.url}`, "_blank");
  return data;
}

export async function descargarLicencia(id) {
  const { data } = await api.post(`/software/${id}/descargar-link?recurso=licencia`);
  const base = process.env.REACT_APP_BACKEND_URL || "";
  window.open(`${base}${data.url}`, "_blank");
  return data;
}
